import * as React from "react";
import cx from "classnames";

import Overlay from "./Overlay";
import "./Modal.css";

export interface ModalProps {
  isOpen: boolean;
  children: any;
  className?: string;
  bodyClassName?: string;
  onClose?: (event: React.SyntheticEvent<any>) => void;
}

const getStyles = ({ onClose, className }: ModalProps) =>
  cx("modal", className, { "modal--clickable": onClose != null });

const getBodyStyles = ({ bodyClassName }: ModalProps) =>
  cx("modal__body", bodyClassName);

const Modal = (props: ModalProps) =>
  props.isOpen ? (
    <Overlay className={getStyles(props)} onClick={props.onClose}>
      <div className="modal__container">
        <div className={getBodyStyles(props)}>{props.children}</div>
      </div>
    </Overlay>
  ) : null;

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.tsx